import i18n from '../../i18n';
import { APPLICANT_TYPES, APPLICATION_TYPE_STRING } from '../constants';

export const secureAccountNameTitle = (applicantType, ApplicationType) => {
  const applicantTypes = {
    [APPLICANT_TYPES.MAIN]:
      APPLICATION_TYPE_STRING[ApplicationType] === APPLICATION_TYPE_STRING[2]
        ? i18n.t('secureName.businessNameTitle')
        : i18n.t('secureName.nameTitle'),
    [APPLICANT_TYPES.SECONDARY]: i18n.t('secureSecondary.nameTitle'),
    [APPLICANT_TYPES.MINOR]: i18n.t('secondaryMinor.nameTitle'),
    [APPLICANT_TYPES.BUSINESS]: i18n.t('secureName.title'),
  };

  return applicantTypes[`${applicantType}`];
};

export const secureAccountDobTitle = (applicantType, name) => {
  const applicantTypes = {
    [APPLICANT_TYPES.MAIN]: i18n.t('secureDob.title', { name }),
    [APPLICANT_TYPES.SECONDARY]:
      name === ''
        ? i18n.t('secureSecondaryDobMissingInfo.title')
        : i18n.t('secureSecondaryDob.title', {
            name,
          }),
    [APPLICANT_TYPES.MINOR]:
      name === ''
        ? i18n.t('secureMinorDobMissingInfo.title')
        : i18n.t('secureSecondaryDob.title', {
            name,
          }),
  };

  return applicantTypes[`${applicantType}`];
};

export const secureAccountIdentityCountryTitle = (applicantType, name) => {
  const applicantTypes = {
    [APPLICANT_TYPES.MAIN]: i18n.t('secureIdentity.title', {
      name,
    }),
    [APPLICANT_TYPES.SECONDARY]:
      name === ''
        ? i18n.t('secureSecondaryIdentityMissingInfo.title', {
            name,
          })
        : i18n.t('secureSecondaryIdentity.title', {
            name,
          }),
    [APPLICANT_TYPES.MINOR]:
      name === ''
        ? i18n.t('secureMinorIdentityMissingInfo.title')
        : i18n.t('secureMinorIdentity.title', {
            name,
          }),
  };

  return applicantTypes[`${applicantType}`];
};

export const secureAccountIrsTitle = (applicantType, name) => {
  const applicantTypes = {
    [APPLICANT_TYPES.MAIN]: i18n.t('secureIdentityIRS.title'),
    [APPLICANT_TYPES.SECONDARY]:
      name === ''
        ? i18n.t('secureSecondaryIdentityIRSMissingInfo.title')
        : i18n.t('secureSecondaryIdentityIRS.title', {
            name,
          }),
  };

  return applicantTypes[`${applicantType}`];
};

export const secureAccountSsnTitle = (applicantType, name, ApplicationType) => {
  const applicantTypes = {
    [APPLICANT_TYPES.MAIN]:
      APPLICATION_TYPE_STRING[ApplicationType] === APPLICATION_TYPE_STRING[2] ||
      APPLICATION_TYPE_STRING[ApplicationType] === APPLICATION_TYPE_STRING[3]
        ? i18n.t('secureIdentitySSN.titleMakeSure')
        : i18n.t('secureIdentitySSN.title'),
    [APPLICANT_TYPES.SECONDARY]:
      name === ''
        ? i18n.t('secureSecondaryIdentitySSNMissingInfo.title')
        : i18n.t('secureSecondaryIdentitySSN.title', {
            name,
          }),
    [APPLICANT_TYPES.MINOR]:
      name === ''
        ? i18n.t('secureMinorIdentitySSNMissingInfo.title')
        : i18n.t('secureMinorIdentitySSN.title', {
            name,
          }),
  };

  return applicantTypes[`${applicantType}`];
};

export const secureAddressSecondOwnerTitle = (applicantType, Name, Address) => {
  const { name } = Name;
  const { address } = Address;
  const applicantTypes = {
    [APPLICANT_TYPES.SECONDARY]:
      name === '' || address === ''
        ? i18n.t('secureSecondaryAddress.titleMissingData')
        : i18n.t('secureSecondaryAddress.title', {
            name,
            address,
          }),
    [APPLICANT_TYPES.MINOR]:
      name === ''
        ? i18n.t('secureMinorAddress.titleMissingData')
        : i18n.t('secureMinorAddress.title', {
            name,
          }),
  };

  return applicantTypes[`${applicantType}`];
};

export const secureAddressEnterTitle = (applicantType, name) => {
  const applicantTypes = {
    [APPLICANT_TYPES.MAIN]:
      name === ''
        ? i18n.t('secureAddressEnter.titleMissingData')
        : i18n.t('secureAddressEnter.title', { name }),
    [APPLICANT_TYPES.SECONDARY]:
      name === ''
        ? i18n.t('secureSecondaryAddressEnter.titleEmptyName')
        : i18n.t('secureSecondaryAddressEnter.title', {
            name: `${name}’s`,
          }),
    [APPLICANT_TYPES.MINOR]:
      name === ''
        ? i18n.t('secureMinorAddressEnterMissingData.title')
        : i18n.t('secureMinorAddressEnter.title', {
            name: `${name}’s`,
          }),
    [APPLICANT_TYPES.BUSINESS]: i18n.t('verifyBusinessAddress.title'),
  };

  return applicantTypes[`${applicantType}`];
};

export const secureAddressEnterSubtitle = (applicantType, name) => {
  const applicantTypes = {
    [APPLICANT_TYPES.MAIN]:
      name === ''
        ? i18n.t('secureAddressEnter.subtitle')
        : i18n.t('secureAddressEnter.subtitle', { name }),
    [APPLICANT_TYPES.SECONDARY]: i18n.t(
      'secureSecondaryAddressEnter.subtitle',
      {
        name,
      },
    ),
    [APPLICANT_TYPES.MINOR]: i18n.t('verifyBusinessAddress.subtitle'),
    [APPLICANT_TYPES.BUSINESS]: i18n.t('verifyBusinessAddress.subtitle'),
  };

  return applicantTypes[`${applicantType}`];
};

export const secureAccountPhoneNumberTitle = (applicantType, name) => {
  const applicantTypes = {
    [APPLICANT_TYPES.MAIN]: i18n.t('securePhoneNumber.title'),
    [APPLICANT_TYPES.SECONDARY]:
      name === ''
        ? i18n.t('secureSecondaryPhoneNumberMissingInfo.title')
        : i18n.t('secureSecondaryPhoneNumber.title', {
            name,
          }),
    [APPLICANT_TYPES.MINOR]:
      name === ''
        ? i18n.t('secureMinorPhoneNumberMissingInfo.title')
        : i18n.t('secureSecondaryPhoneNumber.title', {
            name,
          }),
  };

  return applicantTypes[`${applicantType}`];
};
